import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { LocalizationProvider as MUILocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { frFR } from '@mui/x-date-pickers/locales';
import enLocale from 'date-fns/locale/en-US';
import frLocale from 'date-fns/locale/fr';
export interface Props {
  children: ReactNode;
  locale: 'fr' | 'en';
}
const localeMap = {
  fr: frLocale,
  en: enLocale
};
const LocalizationProvider = t0 => {
  const $ = _c(4);
  const {
    children,
    locale
  } = t0;
  const t1 = localeMap[locale];
  const t2 = locale === "fr" ? frFR.components.MuiLocalizationProvider.defaultProps.localeText : undefined;
  let t3;
  if ($[0] !== children || $[1] !== t1 || $[2] !== t2) {
    t3 = <MUILocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={t1} localeText={t2}>{children}</MUILocalizationProvider>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default LocalizationProvider;